import { render, staticRenderFns } from "./Privicitat.vue?vue&type=template&id=d8a280a8"
import script from "./Privicitat.vue?vue&type=script&lang=js"
export * from "./Privicitat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports